// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__ORBqv","secondary":"button_secondary__B668O"};